import { render, staticRenderFns } from "./current.vue?vue&type=template&id=a56f8216&"
import script from "./current.vue?vue&type=script&lang=js&"
export * from "./current.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports